<template>
    <layout-basic>
        <v-container fluid>
            <v-row>
                <v-col md="12">
                    <v-card flat>
                        <v-card-title>
                            <div class="flex-grow-1"></div>
                        </v-card-title>
                        <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
                        <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                        <v-data-table :headers="computedHeaders" :options.sync="options"
                            :server-items-length="serverItemsLength" v-show="!loading" :items="partners">
                            <template v-slot:item.id="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn :id="item.id" :to="'/super-admin/partner/reports/' + item.user_id"
                                            outlined small color="secondary" v-if="$globalConfig.APP_NAME === 'senso'">
                                            <v-icon small>fa-eye</v-icon>
                                        </v-btn>
                                        <v-btn :id="item.id" :to="'/super-admin/partner/reports/' + item.id"
                                            outlined small color="secondary" v-if="$globalConfig.APP_NAME === 'partner'">
                                            <v-icon small>fa-eye</v-icon>
                                        </v-btn>
                                    </template>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/SuperAdmin";
import partnerAPI from "@/api/partner.js";

export default {
    name: "UsersReport",
    components: {
        LayoutBasic,
    },
    data() {
        return {
            headers: [
                { text: "Partner", value: "company_name" },
                { text: "First Name", value: "first_name", sortable: false },
                { text: "Surname", value: "last_name", sortable: false },
                { text: "Email", value: "email", sortable: false },
                { text: "Created On", value: "created_at" },
                { text: "Last Login", value: "last_login", sortable: false },
                { text: "", value: "id", sortable: false, align: "end" }
            ],
            partners: [],
            search: "",
            searchParams: "",
            pagination: {},
            options: {},
            loading: false,
            line: {},
        };
    },
    computed: {
        computedHeaders() {
            let headers = [...this.headers];
            if (this.$globalConfig.APP_NAME == 'senso') {
                headers.splice(4, 0,
                    { text: "Level", value: "partner_level" }
                );
            }
            return headers;
        },
        serverItemsLength: function () {
            return this.pagination.total;
        },
        itemsPerPage: function () {
            return this.pagination.per_page;
        },
        page: function () {
            return this.pagination.current_page;
        },
        params: function () {
            return this.$gf.getQueryString(this.options, this.serverItemsLength);
        },
        isTabletOrDesktop() {
            const width = this.$vuetify.breakpoint.width;
            return width >= 820;
        },
    },
    watch: {
        options: {
            handler() {
                this.getPartners();
            },
            deep: true
        }
    },
    methods: {
        getPartners() {
            this.loading = true;
            partnerAPI.getPartners(this.params, this.searchParams).then(resp => {
                this.partners = resp.data.data;
                this.pagination = resp.data.meta.pagination;
                this.loading = false;
            });
        },
        resetSearch() {
            this.searchParams = "";
            this.getPartners();
        },
        applySearch() {
            this.searchParams = this.params + "&search=first_name:" + this.search + ";last_name:" + this.search;
            this.getPartners();
        },
    }
};
</script>
